import { Outlet } from "react-router-dom";
import { MarketingNav, Footer, FloatingWidgets } from "@/components/Brand";
import { useCms } from "@/lib/cms";
import NewsTicker from "@/components/NewsTicker";

export default function MarketingLayout() {
  const { ready } = useCms();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* News Ticker — always above nav, no FOUC guard needed (it self-hides when empty) */}
      <NewsTicker />

      {/*
        Nav is always mounted so sticky positioning and scroll behaviour work
        immediately. We hide it with opacity-0 pointer-events-none until the
        CMS branding is ready, then fade it in — this prevents any FOUC without
        causing layout shift (the nav space is reserved from the very first paint).
      */}
      <div
        className="transition-opacity duration-150"
        style={{ opacity: ready ? 1 : 0, pointerEvents: ready ? "auto" : "none" }}
        aria-hidden={!ready}
      >
        <MarketingNav />
      </div>
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingWidgets />
    </div>
  );
}
